import { render, staticRenderFns } from "./ActivityView.vue?vue&type=template&id=0455f440&scoped=true"
var script = {}
import style0 from "./ActivityView.vue?vue&type=style&index=0&id=0455f440&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0455f440",
  null
  
)

export default component.exports